import { Checkbox, Dialog, DialogFooter, Label, PrimaryButton, Stack, Text } from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { Close } from 'kits/IconKit2';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { ICommunicationSettingsState } from './CommunicationSettings.State';

const CommunicationSettingsView: React.FC<ICommunicationSettingsState> = (props) => {
    const { currentDeviceSettings, toggleDeviceSettings, hideErrorDialog, toggleHideErrorDialog, colorButtonId } = props;

    return (
        <>
            <Stack>
                <Label
                    style={{
                        padding: '5px 5px 5px 0px'
                    }}
                >
                    {IvicosStrings.communicationSettings}
                </Label>
                <Stack
                    horizontal
                    style={{
                        padding: '5px 5px 5px 0px'
                    }}
                >
                    <Checkbox
                        checked={currentDeviceSettings.cameraDisabled}
                        onChange={() => {
                            toggleDeviceSettings('camera');
                        }}
                    />
                    <Text variant="medium" style={{ padding: '0vh 1vh' }}>
                        {IvicosStrings.cameraPreferenceActionTitle}
                    </Text>
                </Stack>
                <Stack
                    horizontal
                    style={{
                        padding: '5px 5px 5px 0px'
                    }}
                >
                    <Checkbox
                        checked={currentDeviceSettings.microphoneDisabled}
                        onChange={() => {
                            toggleDeviceSettings('mic');
                        }}
                    />
                    <Text variant="medium" style={{ padding: '0vh 1vh' }}>
                        {IvicosStrings.microphonePreferenceActionTitle}
                    </Text>
                </Stack>
            </Stack>
            <Dialog
                hidden={hideErrorDialog}
                onDismiss={() => {
                    toggleHideErrorDialog();
                }}
            >
                <Stack>
                    <Stack style={{ flexDirection: 'row', justifyContent: 'flex-start', marginTop: '-30px' }}>
                        <IC size={20} variant="red">
                            <Close id={colorButtonId} />
                        </IC>

                        <Text variant="xLarge" style={{ marginLeft: 10 }}>
                            {IvicosStrings.errorOccurred}
                        </Text>
                    </Stack>

                    <Text style={{ marginLeft: 30, marginTop: 10, marginRight: 0, textAlign: 'justify' }}>{IvicosStrings.cameraSettingErrorMessage}</Text>
                </Stack>

                <DialogFooter>
                    <PrimaryButton
                        onClick={() => {
                            toggleHideErrorDialog();
                            window.location.reload();
                        }}
                        text={IvicosStrings.closeActionTitle}
                    />
                </DialogFooter>
            </Dialog>
        </>
    );
};

export default CommunicationSettingsView;
